import { Button, Card, Col, Descriptions, Form, Input, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Subtitle } from '../../components';
import InputMask from '../../components/input-mask';
import { useSiniestroContext } from '../../context/siniestro-context';
import {
  errorHandler,
  formatCelular,
  getMontoCalculado,
  parseCelular,
  prefijos3Digitos,
  relaciones,
  validarCaracterEspecial
} from '../../utils';

import { CONFIG } from '../../constants';
import { instanceRef } from '../../utils/axios';

const ConfirmarDatos = ({ handleChangeSiniestroGenerado, ...props }) => {
  const { datosAsegurado } = useSiniestroContext();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { persona, producto, vehiculo, aseguradoraEmpresa } = datosAsegurado;

  const { aseguradora } = aseguradoraEmpresa;
  const { domicilio, celular } = persona;

  const [planSubcoberturaList, setPlanSubcoberturaList] = useState([]);

  const onFinish = async (values) => {
    const siniestro = {
      id_poliza: datosAsegurado.id,
      idProducto: producto.id,
      persona: {
        id: persona.id,
        nombres: values.nombres,
        celular: `+595${formatCelular(values.celular)}`,
        correo: values.correo
      }
    };

    const reCaptchaToken = await executeRecaptcha('form/siniestro/enviar');

    instanceRef.instance
      .post(`form/siniestro/enviar/`, { siniestro, reCaptchaToken })
      .then((data) => {
        handleChangeSiniestroGenerado(data.data);
      })
      .catch((err) => {
        errorHandler(err, 'Ocurrió un error al momento de guardar los datos');
      });
  };
  const ContactForm = () => {
    return (
      <Card
        style={{ padding: 0 }}
        cover={
          <div
            style={{
              fontSize: 22,
              fontWeight: 'bold',
              background: CONFIG.COLOR_PRIMARY,
              color: 'white',
              padding: 8,
              borderRadius: '6px 6px 0 0'
            }}
          >
            Para enviar la denuncia al cliente, confirmá los siguientes datos:
          </div>
        }
      >
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Nombre y apellido"
              name="nombres"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Nombre y apellido es un campo requerido'
                }
              ]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input placeholder="Nombre del Cliente" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Nro. de contacto"
              name="celular"
              rules={[
                {
                  required: true
                },
                {
                  pattern: `^\\((${prefijos3Digitos.join(
                    '|'
                  )})\\) [0-9]{3}-[0-9]{3}$`,
                  message: 'Número no válido'
                }
              ]}
            >
              <InputMask
                mask="(999) 999-999"
                placeholder="(___) ___-___"
                addonBefore="+595"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Correo"
              name="correo"
              rules={[
                {
                  required: true
                },
                {
                  type: 'email',
                  message: 'El correo no es válido'
                }
              ]}
            >
              <Input placeholder="Ingrese un valor" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    );
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Relación de parentezco',
      dataIndex: 'relacion',
      key: 'relacion',
      render: (_, item) =>
        item.relacion === 'otro'
          ? 'Otro'
          : relaciones.find((relacion) => relacion.value === item.relacion)
              .label
    },
    {
      title: 'Porcentaje',
      dataIndex: 'beneficio',
      key: 'beneficio',
      align: 'right',
      render: (item) => `${item} %`
    }
  ];

  const getPolizaNumero = (poliza) => {
    return poliza?.numero
      ? `${poliza.seccion || ''}-${poliza.numero || ''}-${
          poliza.endoso === null ? '' : poliza.endoso
        }`
      : 'SIN NÚMERO';
  };

  useEffect(() => {
    if (datosAsegurado.id_poliza_masiva === null) {
      setPlanSubcoberturaList(
        datosAsegurado.solicitud.plan.planSubcobertura
          .sort((a, b) => (a.orden > b.orden ? 1 : -1))
          .filter((e) => e.monto !== -1)
      );
      const planSubList = datosAsegurado.solicitud.plan.planSubcobertura;

      setPlanSubcoberturaList(
        planSubList
          .sort((a, b) => (a.orden > b.orden ? 1 : -1))
          .filter((e) => e.monto !== -1)
      );
    }
  }, [
    datosAsegurado.id_poliza_masiva,
    datosAsegurado.solicitud.plan.planSubcobertura
  ]);

  return (
    <div>
      <Form
        onFinish={onFinish}
        name="confirm"
        layout="vertical"
        initialValues={{
          nombres: persona.nombres,
          celular: parseCelular(persona.celular),
          correo: persona.correo
        }}
      >
        <Subtitle>{props.title}</Subtitle>
        <div style={{ marginBottom: '15px' }}>
          <Descriptions
            title="Datos del Asegurado"
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="CI / RUC">
              {persona?.cedula || persona?.ruc || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Asegurado">
              {`${persona?.nombres}` || ''}
            </Descriptions.Item>
            <Descriptions.Item label="Dirección">{domicilio}</Descriptions.Item>
            <Descriptions.Item label="Teléfono">{celular}</Descriptions.Item>
          </Descriptions>

          <Descriptions
            title="Datos de la Póliza"
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="Póliza Nro">
              {getPolizaNumero(datosAsegurado)}
            </Descriptions.Item>
            <Descriptions.Item label="Aseguradora">
              {aseguradora?.nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Franquicia">{}</Descriptions.Item>
          </Descriptions>

          {producto.codigo === 1 && (
            <Descriptions
              title="Datos del Vehículo"
              style={{ textAlign: 'left', paddingBottom: 40 }}
              bordered
              size="small"
              column={{ md: 2, sm: 1, xs: 1 }}
            >
              <Descriptions.Item label="Marca">
                {vehiculo?.marca.descripcion}
              </Descriptions.Item>
              <Descriptions.Item label="Modelo">
                {vehiculo?.modelo.descripcion}
              </Descriptions.Item>
              <Descriptions.Item label="Submodelo">
                {vehiculo?.submodelo.descripcion}
              </Descriptions.Item>
              <Descriptions.Item label="Año">
                {vehiculo?.aniosubmodelo.descripcion}
              </Descriptions.Item>

              <Descriptions.Item label="Chassis">
                {vehiculo?.chassis}
              </Descriptions.Item>
              <Descriptions.Item label="Chapa">
                {vehiculo?.chapa}
              </Descriptions.Item>
            </Descriptions>
          )}

          {(producto.codigo === 4 || producto.codigo === 5) && (
            <>
              <Descriptions
                title="Datos de la ubicación Asegurada"
                style={{ textAlign: 'left', paddingBottom: 40 }}
                bordered
                size="small"
                column={{ md: 1, sm: 1, xs: 1 }}
              >
                <Descriptions.Item
                  label="Domicilio"
                  labelStyle={{ width: '15em' }}
                >
                  {datosAsegurado.solicitud.inmueble.domicilio}
                </Descriptions.Item>
                <Descriptions.Item label="Distrito">
                  {datosAsegurado.solicitud.inmueble.distrito.descripcion}
                </Descriptions.Item>
                <Descriptions.Item label="Departamento">
                  {datosAsegurado.solicitud.inmueble.departamento.descripcion}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}

          {(producto.codigo === 3 || producto.codigo === 2) && (
            <Descriptions
              title="Detalle de Beneficiario/s"
              style={{ textAlign: 'left', marginTop: 30 }}
            >
              <Descriptions.Item label="">
                <Table
                  fixed
                  scroll={false}
                  style={{ width: '100%' }}
                  bordered
                  dataSource={datosAsegurado.solicitud.beneficiarios}
                  columns={columns}
                  pagination={false}
                  rowKey={(record) => record.id}
                />
              </Descriptions.Item>
            </Descriptions>
          )}
          {datosAsegurado.id_poliza_masiva === null && (
            <Descriptions
              title="Datos de Coberturas"
              style={{ textAlign: 'left', marginTop: 30 }}
            >
              {planSubcoberturaList.map((elem) => (
                <>
                  <Descriptions.Item label="">
                    <span
                      style={{
                        textTransform: 'capitalize',
                        fontWeight: 'bold'
                      }}
                    >
                      {elem.subcobertura.c?.descripcion?.toLowerCase() || ''}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label="">
                    {getMontoCalculado(elem, false)}
                  </Descriptions.Item>
                  <Descriptions.Item label="">
                    {elem.franquicia_descripcion
                      ? elem.franquicia_descripcion
                      : 'Sin Franquicia'}
                  </Descriptions.Item>
                </>
              ))}
            </Descriptions>
          )}
        </div>
        {props.contact && (
          <>
            <ContactForm />{' '}
            <div style={{ marginTop: '10px' }}>
              <Button type="primary" htmlType="submit">
                Siguiente
              </Button>
            </div>
          </>
        )}{' '}
      </Form>
    </div>
  );
};

export default ConfirmarDatos;
